export const orderTotalMixin = {
    methods: {
        unitTotal: function (products) {
            let totalUnits = 0

            for (const product of products) {
                if (product.packagings !== undefined && product.packagings > 0) {
                    totalUnits += (parseInt(product.packagings) * parseInt(product.unitsPerPackaging))
                }

                if (product.units !== undefined && product.units > 0) {
                    totalUnits += parseInt(product.units)
                }
            }

            return totalUnits
        },
        packagingTotal(products) {
            let totalPackagings = 0

            for (const product of products) {
                if (product.units !== undefined && product.units > 0) {
                    totalPackagings += (parseInt(product.units) / parseInt(product.unitsPerPackaging))
                }

                if (product.packagings !== undefined && product.packagings > 0) {
                    totalPackagings += parseInt(product.packagings)
                }
            }

            return totalPackagings.toFixed(2)
        },
        orderPriceTotal(products) {
            let totalOrderPrice = 0

            for (const product of products) {
                if (product.units !== undefined && product.units > 0)
                    totalOrderPrice += (parseInt(product.units) * parseFloat(product.pricePer))

                if (product.packagings !== undefined && product.packagings > 0)
                    totalOrderPrice += (parseInt(product.packagings) * parseFloat(product.pricePer))
            }

            return totalOrderPrice.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            })
        },
    },
}
